export default __webpack_public_path__ + "images/instagram.svg?88158dbe0dfb932c7dd633c363705559";